export function formatMillionsNumber(
  num: number,
  showThousands = false,
): string {
  if (num >= 1_000_000_000_000) {
    return formatAbbreviated(num, 1_000_000_000_000, 'T');
  }

  if (num >= 1_000_000_000) {
    return formatAbbreviated(num, 1_000_000_000, 'B');
  }

  if (num >= 1_000_000) {
    return formatAbbreviated(num, 1_000_000, 'M');
  }

  if (showThousands && num >= 1_000) {
    return formatAbbreviated(num, 1_000, 'K');
  }

  if (num >= 100_000) {
    return formatAbbreviated(num, 1_000_000, 'M');
  }

  return num.toLocaleString();
}

function formatAbbreviated(
  num: number,
  divisor: number,
  suffix: string,
): string {
  return num % divisor === 0
    ? `${num / divisor}${suffix}`
    : `${(num / divisor).toFixed(1)}${suffix}`;
}
